<template>
  <v-container class="grey lighten-5">
    <h2>Planejamento</h2>
    
      <v-col class="d-flex" cols="12" sm="6">
        <v-select
          :items="allDemands"
          item-text="name"
          item-value="id"
          label="Demanda"
          @change="getvalueDemandSelected"
          solo
        ></v-select>
      </v-col>

  <v-card :class="{'d-none': !valueDemandSelected}">
    <v-tabs >
      <v-tab>
        <v-icon left>mdi-account</v-icon>
        Equipe
        
      </v-tab>
      <v-tab>
        <v-icon left>mdi-view-list</v-icon>
        Atividades
      </v-tab>
      <v-tab-item class="container">
        <v-card flat>

          <v-btn @click="setTeam"
          class="mx-2" fab dark
          >
            <v-icon dark>mdi-account-cog</v-icon> 
          </v-btn>
          

          <v-list>
            <v-list-item
              v-for="team in planningTeam"
              :key="team.id"
            >
              <v-list-item-content>
                <v-list-item-title v-text="team.shortName"></v-list-item-title>
              </v-list-item-content>

              <v-list-item-content>
                <v-list-item-title v-text="team.modulo"></v-list-item-title>
              </v-list-item-content>

              <v-list-item-content>
                <v-list-item-title v-text="team.id"></v-list-item-title>
              </v-list-item-content>

              <v-list-item-content>
                <v-list-item-title v-text="team.phone"></v-list-item-title>
              </v-list-item-content>              

              <v-list-item-icon>
                  <v-icon @click="openInNewTab(team.phone)"
                    color="green"
                  >
                    mdi-whatsapp
                  </v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>

          <v-btn @click="teste" class="d-none">Teste</v-btn>     
            

        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-form ref="formTasks" v-model="valid" >
              <v-container :fluid="true">
                <v-row>

                  <v-col cols="12" sm="6" md="3">
                    <v-select :value = "formTasks.type" @change="v => formTasks.type = v"
                      required :rules="[ v => !!v || 'Tipo obrigatório']"
                      :items="tipoAtividade"
                      item-text="name"
                      item-value="type"                      
                      label="Tipo"
                      outlined
                      dense
                    ></v-select>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <v-text-field :value = "formTasks.text" @change="v => formTasks.text = v"
                      required :rules="[ v => !!v || 'Descrição obrigatória']"
                      label="Descrição"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>                  

                  <v-col cols="12" sm="6" md="3">
                    <v-text-field :value = "formTasks.start" @change="v => formTasks.start = v"
                      required :rules="[ v => !!v || 'Inicio obrigatório']"
                      label="Inicio"
                      outlined
                      dense
                      type="date"
                    ></v-text-field>
                  </v-col>                                    

                  <v-col cols="12" sm="6" md="3">
                    <v-text-field :value = "formTasks.end" @change="v => formTasks.end = v"
                      required :rules="[ v => !!v || 'Fim obrigatório']"
                      label="Fim"
                      outlined
                      dense
                      type="date"
                    ></v-text-field>
                  </v-col> 
                                                    

                </v-row>
              </v-container>

            <v-btn @click="saveTasks()"
                dark small color="blue-grey darken-3"
            >Inserir Atividade
            </v-btn>

            </v-form>



            <v-divider class="mt-4"></v-divider>

              <v-subheader>Atividades Registradas</v-subheader>

              <v-container class="grey lighten-5">
                <v-row
                  v-for="(task, index) in planningTasks"
                  :key="index"
                  no-gutters
                >
                  <v-col cols="12" sm="6" md="3" >
                    <v-card
                      class="pa-2 font-weight-black"
                      outlined
                      tile
                      color="blue-grey lighten-2"
                    >
                      {{task.text}}
                    </v-card>
                  </v-col>


                  <v-col cols="12" sm="6" md="3" >
                    <v-card
                      class="pa-2"
                      outlined
                      tile
                    >
                      {{firestoreLocalDate(task.start)}}
                      
                      
                    </v-card>
                  </v-col>

                  <v-col cols="12" sm="6" md="3" >
                    <v-card
                      class="pa-2"
                      outlined
                      tile
                    >
                    {{firestoreLocalDate(task.end)}}
                    
                    </v-card>
                  </v-col>

                  <v-col cols="12" sm="6" md="3" >
                    <v-card
                      class="pa-2"
                      outlined
                      tile
                    >
                      {{task.status}}.
                    </v-card>
                  </v-col>

                    <v-col cols="6">
                      <v-card
                        class="pa-2"
                        outlined
                        tile
                      >
                        {{zjoin([task.team])}}
                        
                      </v-card>
                    </v-col>        




                    <v-col cols="6">

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click="setTeamTask(index)"
                            icon
                            v-bind="attrs"
                            v-on="on"
                            class="ml-4"
                            color="green"
                          >
                            <v-icon >mdi-account-multiple-plus</v-icon>
                          </v-btn>                        
                          
                        </template>
                        <span>Associar Responsáveis</span>
                      </v-tooltip>
                        <v-btn @click="deleteTask(index)"
                          icon
                          dark 
                          class="ml-4"
                          color="red"
                        >
                          <v-icon >mdi-delete</v-icon>
                        </v-btn>                      

                    </v-col>                  


                </v-row>

              </v-container>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-card>

  
  <v-dialog
    v-model="dialogSetTeam.active"
    max-width="480"
  >
    <v-card>
      <v-card-title class="headline">Equipe</v-card-title>

      <v-card-text>
        Defina a equipe da demanda ou atividade

          <v-col cols="12" sm="6">
            <v-select
              v-model="dialogModelTeam"
              :items="dialogItemsTeam"
              item-text="shortName"
              item-value="id"
              label="Consultor"
              multiple
            ></v-select>
          </v-col>

      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          color="green darken-1"
          text
          @click="dialogSetTeam.active = false"
        >
          Cancelar
        </v-btn>

        <v-btn
          color="green darken-1"
          text
          @click="saveTeam"
        >
          Gravar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>





  </v-container>




</template>

<script>
import { mapGetters } from 'vuex';

import fb from '@/firebaseConfig'

const viewCollection = fb.planningCollection;

export default {
  
  data: () => ({
    
    valid: false,
    
    dialogSetTeam: {active: false, index: -1},
    dialogItemsTeam: [],
    dialogModelTeam: [],

    valueDemandSelected: '',
    demandSelect: '',
    

    formTasks: {
      type: '', text: '', start: '', end: ''
    },
    
    tasks: [],

    tipoAtividade: [
      { type: 'PLAN', name: 'Planejamento'},
      { type: 'ESPEC', name: 'Especificação'},      
      { type: 'DEV', name: 'Desenvolvimento'},      
      { type: 'TSTDEV', name: 'Teste DEV'},      
      { type: 'TSTQUA', name: 'Teste QUA'},
      { type: 'TSTHOMO', name: 'Teste Homologação'},
      { type: 'HOMOL', name: 'Homologação'},      
      { type: 'TREIN', name: 'Treinamento'},      
      { type: 'PREPRD', name: 'Pré-Produção'},
      { type: 'GOLIVE', name: 'Go-Live'},            
      { type: 'POSPRD', name: 'Pós-Produção'}  
    ]

  }),

  computed:{
    ...mapGetters(['allDemands','allTeam','allPlanning']),

    
    allPlanningSelected: function(){
      return this.allPlanning.filter(item => item.id == this.demandSelect.id)
              

    },

    planningTasks: function () {
            return this.allPlanning
              .filter(item => item.id == this.demandSelect.id)
              .map(item => item.tasks !== undefined ? item.tasks : [] )
              .flat()
    },
    
    planningTeam: function () {
      
      const filterTeam = this.allPlanning
              .filter(item => item.id == this.demandSelect.id)
              .map(item => item.team )
              .flat()

      let pTeam = [];
      
      for (let index = 0; index < filterTeam.length; index++) {
        
        const element = filterTeam[index];

        let shortName;
        let modulo;
        let phone;
        
        

        const shortNameIndex = this.allTeam.findIndex(item => item.id == element);
        if (shortNameIndex!== -1) {
            shortName = this.allTeam[shortNameIndex].shortName;
            modulo = this.allTeam[shortNameIndex].modulo;
            phone = this.allTeam[shortNameIndex].phone;

        }

        if (element) {
          pTeam.push({ 
            id: element,
            shortName: shortName,
            modulo: modulo,
            phone: phone
           })          
        }


        
      }
     


      return pTeam;

    }
  },

  methods:{
    getvalueDemandSelected(value){
      this.valueDemandSelected = value;
      const dsel = this.allDemands.filter(item => item.id == value);
      this.demandSelect = dsel[0];
    },


    saveTeam(){
      
      let tasksArray = []
        
      let itemUpdate = {};
      

      if (this.dialogSetTeam.index !== -1) {
        
        tasksArray = tasksArray.concat(this.planningTasks);
        
        tasksArray[this.dialogSetTeam.index].team = this.dialogModelTeam
        
        itemUpdate.tasks = tasksArray;

      } else{
        itemUpdate.team = this.dialogModelTeam;
      }


      viewCollection.doc(this.valueDemandSelected).update(itemUpdate)
      .then(function() {
          console.log("Document successfully written!");
      })
      .then(this.snackbarMsg = 'registro incluido com sucesso')
      .then(this.snackbar = true)
      .catch(function(error) {
          console.error("Error writing document: ", error);
      });

      this.dialogSetTeam.active = false;

    },


    setTeam(){

      this.dialogModelTeam = this.planningTeam
      this.dialogItemsTeam = this.allTeam;
      this.dialogSetTeam.active = true;
      this.dialogSetTeam.index = -1;
      console.log('set team');

    },


    setTeamTask(index){

      this.dialogModelTeam = this.planningTasks[index]?.team;
      this.dialogItemsTeam = this.planningTeam;

      this.dialogSetTeam.active = true;
      this.dialogSetTeam.index = index;
    },


    saveTasks(){
      
      if (this.$refs.formTasks.validate()) {
        
        let tasksArray = []
        tasksArray = tasksArray.concat(this.planningTasks);

        this.formTasks.start = this.dateYYYYMMDD(this.formTasks.start);
        this.formTasks.end = this.dateYYYYMMDD(this.formTasks.end);
        
        tasksArray.unshift(Object.assign({}, this.formTasks));
        
        const taskItems = { tasks: tasksArray}


        viewCollection.doc(this.valueDemandSelected).update(taskItems)
        .then(function() {
            console.log("Document successfully written!");
        })
        .then(this.snackbarMsg = 'registro incluido com sucesso')
        .then(this.snackbar = true)
        .then(Object.keys(this.formTasks).forEach( item => this.formTasks[item] = ''))
        .catch(function(error) {
            console.error("Error writing document: ", error);
        });
        

        this.$refs.formTasks.resetValidation();

      }

    },

    deleteTask(index){
      console.log(index);
      alert('função não implementada ainda');
    },

    zjoin(item){
      
      let itemFlat = item.flat();
      let res;
                  
      itemFlat.forEach(element => {
          let shortName = this.planningTeam
                              .filter( item => item.id == element )
                              .map(item => item.shortName)
          !res ? res = shortName.join() : res = `${res}, ${shortName}`
      });

      
      
      
      return res ? res : 'responsável não atribuido'
    },

    openInNewTab(phone){
        window.open(`https://api.whatsapp.com/send?phone=55${phone}`);
    },

    dateYYYYMMDD(vdate) {
      const zdate = vdate.split('-')
      let ano = parseInt(zdate[0])
      let mes = parseInt(zdate[1])
      let dia = parseInt(zdate[2])

      mes = mes == 12 ? 11 : mes - 1

      return new Date(ano,mes,dia)

    },

    firestoreLocalDate(zdate) {
      
      return zdate.toDate().toLocaleDateString();
    },
    
    teste(){
      console.log('All Planning');
      console.log(this.allPlanning);
      
      console.log('Demanda Selecionada');
      console.log(this.demandSelect);


      console.log('Planning Team');
      console.log(this.planningTeam);
  
      console.log('allPlanningSelected');
      console.log(this.allPlanningSelected);

      console.log('planningTasks');
      console.log(this.planningTasks);

     
      
    }





  },
  
  created() {
    
    

  },

} 
</script>

<style scoped>

</style>